/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.tickets.create.description.controllers', [
  'acme.common.service.ticketConfig'
])

.controller('LayoutsTicketsCreateDescriptionController', ['$scope', 'TicketConfigService', function($scope, TicketConfigService) {

    $scope.layoutsTicketsCreateDescription = {

      model: {},

      init: function() {
        this.model = TicketConfigService.getModel();
        $scope.$on('LayoutsTickets::Update', this.onLayoutsTicketsUpdate);
        $scope.$on('LayoutsTickets::Save', this.onLayoutsTicketsSave);
      },

      save: function() {
        TicketConfigService.setModel(this.model);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onLayoutsTicketsSave: function(e, data) {
        var self = $scope.layoutsTicketsCreateDescription;
        self.save();
      },

      onLayoutsTicketsUpdate: function(e, data) {
        var self = $scope.layoutsTicketsCreateDescription;
        self.model = TicketConfigService.getModel();
      }

    };

    $scope.layoutsTicketsCreateDescription.init();

}]);